module.exports = __webpack_public_path__ + "static/media/accepted-cards.6a3c1848.png";